export const types = {
  CHAT_REGISTRATION_REQUEST: 'auth/registation/CHAT_REGISTRATION_REQUEST',
  CHAT_REGISTRATION_SUCCESS: 'auth/registration/CHAT_REGISTRATION_SUCCESS',
  CHAT_REGISTRATION_ERROR: 'auth/registration/CHAT_REGISTRATION_ERROR',
  REGISTRATION_REQUEST: 'auth/registration/REGISTRATION_REQUEST',
  REGISTRATION_SUCCESS: 'auth/registration/REGISTRATION_SUCCESS',
  REGISTRATION_ERROR: 'auth/registration/REGISTRATION_ERROR',
  DECLINE_INVITE: 'auth/registration/DECLINE_INVITE',
};

export const registration = {
  request: (key, data, acceptedTerms) => ({
    type: types.REGISTRATION_REQUEST,
    payload: { key, data, acceptedTerms },
  }),
  success: () => ({
    type: types.REGISTRATION_SUCCESS,
  }),
  error: (error) => ({
    type: types.REGISTRATION_ERROR,
    payload: error,
  }),
};

export const chatRegistration = {
  request: (key, data) => ({
    type: types.CHAT_REGISTRATION_REQUEST,
    payload: { key, data },
  }),
  success: () => ({
    type: types.CHAT_REGISTRATION_SUCCESS,
  }),
  error: (error) => ({
    type: types.CHAT_REGISTRATION_ERROR,
    payload: error,
  }),
};
